// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Main_wrapper__3dfG9"};